import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { ProgressSpinner } from "primereact/progressspinner";
import { genElBoolean, genElNumber, genElText } from "../../../components/utils/EditorDialogElementGenerator";

const editTitle = "Edit Jenis Minyak";
const addTitle = "Tambah Jenis Minyak";

const JenisMinyakEditorDialog = (props) => {
  const {
    visible,
    onHide,
    onConfirm,
    loading,
    title,
    data,
    setData,
    addNewMode,
    error,
    setError,
  } = props;

  /**
   * Validates the form data.
   *
   * @returns {boolean} - Returns true if the data is valid, otherwise false.
   * @returns {object} - Returns an object containing the error messages, format { field: message}.
   */
  const validate = () => {
    let valid = true;
    let newEror = {};

    const nama = data.nama ? data.nama.trim() : data.nama;
    if (nama === "" || nama === null || nama === undefined) {
      newEror = { ...newEror, nama: "Nama harus diisi" };
      valid = false;
    }
    const harga = data.harga_per_liter;
    if (harga === null || harga === undefined || isNaN(harga) || harga < 0) {
      newEror = { ...newEror, harga_per_liter: "Harga per liter harus diisi" };
      valid = false;
    }
    const status = data.status;
    if (status === null || status === undefined) {
      newEror = { ...newEror, status: "Status harus diisi" };
      valid = false;
    }

    if (!valid) setError(newEror);

    return valid;
  };

  /**
   * Generate Dialog Form Element
   *
   * various function to generate
   *
   * genElText({ field, name, data, setData, disabled, autoFocus, error })
   * genElTextPassword({ field, name, data, setData, disabled, autoFocus, error })
   * genElTextDropdown({ field, name, data, setData, options, disabled, autoFocus, error, optionLabel = "name" })
   * genElNumber({ field, name, data, setData, min_fraction_digits, max_fraction_digits, min, max, disabled, autoFocus, error })
   * genElNumberDropdown({ field, name, data, setData, options, disabled, autoFocus, error, optionLabel = "name" })
   * genElBoolean({ field, name, data, setData, labelTrue = "Ya", labelFalse = "Tidak", disabled, autoFocus, error })
   * genElDate({ field, name, data, setData, primeFormat, min, max, showTime, time, month, year, disabled, autoFocus, error })
   * genElObject({ field, name, value, onClick, selectorGenerator, disabled, autoFocus, error })
   */

  const elNama = genElText({
    field: "nama",
    name: "Nama",
    data,
    setData,
    error,
  });
  const elHarga = genElNumber({
    field: "harga_per_liter",
    name: "Harga per Liter",
    data,
    setData,
    error,
  });
  const elStatus = genElBoolean({
    field: "status",
    name: "Status",
    data,
    setData,
    labelTrue: "Aktif",
    labelFalse: "Tidak Aktif",
    error,
  });
  const elKeterangan = genElText({
    field: "keterangan",
    name: "Keterangan",
    data,
    setData,
    error,
  });


  const dialogFooter = (
    <React.Fragment>
      <Button
        label="Cancel"
        icon="pi pi-times"
        outlined
        onClick={props.onHide}
      />
      <Button
        label="Save"
        icon="pi pi-check"
        onClick={(e) => {
          const valid = validate();
          if (valid) {
            onConfirm(data);
          }
        }}
      />
    </React.Fragment>
  );

  return (
    <Dialog
      visible={visible}
      style={{ width: "32rem" }}
      breakpoints={{ "960px": "75vw", "641px": "90vw" }}
      header={addNewMode ? addTitle : editTitle}
      modal
      className={`p-fluid`}
      footer={dialogFooter}
      onHide={onHide}
    >
      <div className="col-start-center relative h-100">
        <div className={`row-start-start w-100`}>
          <div className="col-start-start w-100 gap-3">
            {elNama}
            {elHarga}
            {elStatus}
            {elKeterangan}
          </div>
          <div className="col-start-start"></div>
        </div>
        {loading && (
          <div
            className={`col-center-center w-100  gap-2 absolute z-100 h-100 bg-black/20 rounded `}
          >
            <ProgressSpinner />
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default JenisMinyakEditorDialog;
